module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight-2cda9dc521150a2e30af477aa499dc90.png";